"use strict";

var _defineProperty2 = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");
var _classCallCheck = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _possibleConstructorReturn = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");
var _inherits = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _utils = require("../utils");
var _reactIntl = require("react-intl");
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    default: e
  };
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var ImageCell = /*#__PURE__*/function (_react$default$Compon) {
  function ImageCell() {
    _classCallCheck(this, ImageCell);
    return _callSuper(this, ImageCell, arguments);
  }
  _inherits(ImageCell, _react$default$Compon);
  return _createClass(ImageCell, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
      return (0, _utils.shouldCellComponentUpdate)(this.props, nextProps) || this.state !== nextState;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        defaultLanguage = _this$props.defaultLanguage,
        cell = _this$props.cell,
        uriTransformer = _this$props.uriTransformer,
        intl = _this$props.intl;
      var image_uri = (0, _utils.i18nData)(cell, 'image_uri', intl, defaultLanguage);
      if (!image_uri) return null;
      return /*#__PURE__*/_react.default.createElement("img", {
        style: _objectSpread({
          position: 'relative',
          width: '100%',
          height: '100%',
          objectFit: 'cover'
        }, this.props.style),
        src: uriTransformer(image_uri)
      });
    }
  }]);
}(_react.default.Component);
_defineProperty(ImageCell, "whyDidYouRender", true);
_defineProperty(ImageCell, "defaultProps", {
  uriTransformer: function uriTransformer(u) {
    return u;
  }
});
var _default = exports.default = (0, _reactIntl.injectIntl)(ImageCell);